let self = module.exports = {
    convertToFt: (value, unit) => {
        switch (unit) {
            case 'm':
                return 3.2808 * value;
            case 'cm':
                return 0.3281 * value;
            case 'mm':
                return 0.0328 * value;
            case 'in':
                return 0.0833 * value;
            default:
                return value;
        }
    },

    calculatorArea: (width, height, length, input_type) => {
        switch (input_type) {
            case 'WxH':
                return width * height;
            case 'WxL':
                return width * length;
            case 'HxL':
                return length * height;
            default:
                return width * height;
        }
    },

    convertPrice: (price) => {
        let priceArr = price.split('.')
        let priceInt = parseInt(priceArr[0]).toLocaleString()
        let priceSecond = priceArr[1] || ''
        return `${priceInt}.${priceSecond}`
    },

    convertPriceNumber: (price) => {
        price = parseFloat(price)
        if (isNaN(price)) return '0.00'
        price = price.toFixed(2)
        let priceArr = price.split('.')
        let priceInt = parseInt(priceArr[0]).toLocaleString()
        let priceSecond = priceArr[1] || ''
        return `${priceInt}.${priceSecond}`
    },

    getFloor: (floor) => {
        switch (floor) {
            case 1: 
                return floor + 'st';
            case 2: 
                return floor + 'nd';
            case 3: 
                return floor + 'rd';
            default: 
                return floor + 'th';
        }
    },

    formartDateTime : (time) => {
        if (!time) return ''
        let d = new Date(time);
        let curr_date = d.getDate();
        let curr_month = d.getMonth() + 1;
        let curr_year = d.getFullYear();
        let curr_hours = d.getHours();
        let curr_minus = d.getMinutes();
        let curr_second = d.getSeconds();
    
        curr_minus = (curr_minus < 10) ? '0'+curr_minus : curr_minus;
        curr_hours = (curr_hours < 10) ? '0'+curr_hours : curr_hours;
        curr_date = (curr_date < 10) ? '0'+curr_date : curr_date;
        curr_month = (curr_month < 10) ? '0'+curr_month : curr_month;
    
        return  curr_hours + ':' + curr_minus + '      ' + curr_date + "/" + curr_month + "/" + curr_year ;
    },

    formartDate(time) {
        if (!time) return '';
        let d = new Date(time);
        let curr_date = d.getDate();
        let curr_month = d.getMonth() + 1;
        let curr_year = d.getFullYear();

        curr_date = (curr_date < 10) ? '0' + curr_date : curr_date;
        curr_month = (curr_month < 10) ? '0' + curr_month : curr_month;

        return `${curr_date}.${curr_month}.${curr_year}`;
    },

    calculatorPriceItem: (priceItemEdit = {}, priceItemContractor, items, area_items_id, quote_room_id) => {
        let item_id = items._id
        let key = `${area_items_id}_${quote_room_id}`
        let priceItem = priceItemEdit[key] ? priceItemEdit[key] : (priceItemContractor[item_id] ? priceItemContractor[item_id] : {price: items.price, type_item: 0});
        return priceItem
    },

    numberToEnglish: (n, custom_join_character) => {

        var string = n.toString(),
            units, tens, scales, start, end, chunks, chunksLen, chunk, ints, i, word, words;
    
        var and = custom_join_character || '';
    
        /* Is number zero? */
        if (parseInt(string) === 0) {
            return 'zero';
        }
    
        /* Array of units as words */
        units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    
        /* Array of tens as words */
        tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Sighty', 'Ninety'];
    
        /* Array of scales as words */
        scales = ['', 'Thousand', 'Million', 'Billion', 'Trillion', 'Quadrillion', 'Quintillion', 'Sextillion', 'Septillion', 'Octillion', 'Nonillion', 'Decillion', 'Undecillion', 'Duodecillion', 'Tredecillion', 'Quatttuor-decillion', 'Quindecillion', 'Sexdecillion', 'Septen-decillion', 'Octodecillion', 'Novemdecillion', 'Vigintillion', 'Centillion'];
    
        /* Split user arguemnt into 3 digit chunks from right to left */
        start = string.length;
        chunks = [];
        while (start > 0) {
            end = start;
            chunks.push(string.slice((start = Math.max(0, start - 3)), end));
        }
    
        /* Check if function has enough scale words to be able to stringify the user argument */
        chunksLen = chunks.length;
        if (chunksLen > scales.length) {
            return '';
        }
    
        /* Stringify each integer in each chunk */
        words = [];
        for (i = 0; i < chunksLen; i++) {
    
            chunk = parseInt(chunks[i]);
    
            if (chunk) {
    
                /* Split chunk into array of individual integers */
                ints = chunks[i].split('').reverse().map(parseFloat);
    
                /* If tens integer is 1, i.e. 10, then add 10 to units integer */
                if (ints[1] === 1) {
                    ints[0] += 10;
                }
    
                /* Add scale word if chunk is not zero and array item exists */
                if ((word = scales[i])) {
                    words.push(word);
                }
    
                /* Add unit word if array item exists */
                if ((word = units[ints[0]])) {
                    words.push(word);
                }
    
                /* Add tens word if array item exists */
                if ((word = tens[ints[1]])) {
                    words.push(word);
                }
    
                /* Add 'and' string after units or tens integer if: */
                if (ints[0] || ints[1]) {
    
                    /* Chunk has a hundreds integer or chunk is the first of multiple chunks */
                    if (ints[2] || !i && chunksLen) {
                        words.push(and);
                    }
    
                }
    
                /* Add hundreds word if array item exists */
                if ((word = units[ints[2]])) {
                    words.push(word + ' Hundred');
                }
    
            }
    
        }
    
        return words.reverse().join(' ');
    
    },

    convertPriceToNumber: (number) => {
        number = parseFloat(number)
        number = number.toFixed(2)
        let priceArr = number.split('.')

        let firstStr = self.numberToEnglish(parseInt(priceArr[0])) + ' Dollars'
        let secondStr = priceArr[1] == '00' ? '' : self.numberToEnglish(parseInt(priceArr[1])) + ' Cents'

        return (secondStr) ? firstStr + ' and ' + secondStr : firstStr
    },

    getTimePDF: () => {
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        let d = new Date()
        let curr_date = d.getDate();
        let curr_month = d.getMonth();
        let curr_year = d.getFullYear();

        curr_date = (curr_date < 10) ? '0' + curr_date : curr_date;
        curr_year = curr_year.toString().substr(-2)
        return `${curr_date}-${monthNames[curr_month]}-${curr_year}`
    },
}